import { ExportRfidReportsExcel } from "./ExportRfidReportsExcel";
import { ExportRfidReportsPdf } from "./ExportRfidReportsPdf";

export const ExportRfidReports = ({ rfidReportData = [] }) => (
  <>
    <ExportRfidReportsExcel rfidReportData={rfidReportData} />
    <ExportRfidReportsPdf rfidReportData={rfidReportData} />
  </>
);
